export default "__VITE_ASSET__DFDW3Qiq__"